<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本赞助类别" prop="type" >
        <a-select placeholder="请选择剧本赞助类别" style="width: 100%" v-model="form.type" allowClear>
          <a-select-option v-for="(item, index) in this.customDict.SponsorTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="赞助剧本" prop="scriptId">
        <a-button type="dashed" @click="showBindScript" danger v-if="form.scriptName">
          <span>{{ form.scriptName }}</span>
        </a-button>
        <a-button type="dashed" @click="showBindScript" danger v-if="!form.scriptName">
          <span style="color: dodgerblue"> 绑定剧本</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="赞助名称" prop="sponsorName" >
        <a-input v-model="form.sponsorName" :maxLength="20" placeholder="请输入赞助名称" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="img" >
        <oss-multi-upload
          v-model="form.img"
          type="img"
          :maxCount="1"
          :maxSize="5"
          :isMultiple="false"
        ></oss-multi-upload>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" style="width: 100%" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-select placeholder="请选择状态" style="width: 100%" v-model="form.status" allowClear>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
        <!--        <a-switch v-model="form.status" />{{ form.status === 1 ? '启用' : '禁用' }}-->
      </a-form-model-item>
      <a-form-model-item label="开始时间" prop="startTime" >
        <a-date-picker
          style="width: 100%"
          v-model="form.startTime"
          @change="onDateChange"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :placeholder="form.type === 9 ? '保存后算法计算' : '请选择日期'"
          allow-clear
          :disabled="form.type === 9"
        />
      </a-form-model-item>
      <a-form-model-item label="结束时间" prop="endTime" >
        <a-date-picker
          style="width: 100%"
          v-model="form.endTime"
          @change="onDateChange1"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :placeholder="form.type === 9 ? '保存后算法计算' : '请选择日期'"
          allow-clear
          :disabled="form.type === 9"
        />
      </a-form-model-item>
      <!--      <a-form-model-item label="逻辑删除标记 1:删除,0:未删除" prop="isDeleted" v-if="formType === 1">-->
      <!--        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记 1:删除,0:未删除" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <!--      <a-form-model-item label="版本号" prop="version" v-if="formType === 1">-->
      <!--        <a-input v-model="form.version" placeholder="请输入版本号" />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <index-script-modal
      ref="IndexScriptModal"
      @select="indexScriptModalSelect"
      @selectName="indexScriptModalName"
    ></index-script-modal>
  </a-drawer>
</template>

<script>
import { getSponsor, addSponsor, updateSponsor } from '@/api/script/sponsor'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'
import { mapGetters } from 'vuex'
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import { timeCompare } from '@/utils/util'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    IndexScriptModal,
    OssMultiUpload
  },
  data () {
    const startTimeVal = (rule, value, callback) => {
      // 全部速递媒体支持剧本时间由后台计算
      if (this.form.type === 9) {
        callback()
      }
      if (!value || value === '') {
        callback(new Error('请选择开始时间'))
      } else if (this.form.endTime) {
        if (timeCompare(value, this.form.endTime) >= 0) {
          callback(new Error('开始时间不能大于结束时间！'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const endTimeVal = (rule, value, callback) => {
      // 全部速递媒体支持剧本时间由后台计算
      if (this.form.type === 9) {
        callback()
      }
      if (!value || value === '') {
        callback(new Error('请选择结束时间'))
      } else if (this.form.startTime) {
        if (timeCompare(this.form.startTime, value) >= 0) {
          callback(new Error('开始时间不能大于结束时间！'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        scriptId: null,
        scriptName: null,
        type: undefined,
        sponsorName: null,
        img: null,
        sort: null,
        status: 1,
        startTime: null,
        endTime: null,
        createTime: null,
        modifier: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        scriptId: [
          { required: true, message: '请绑定剧本', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择剧本赞助类别', trigger: 'change' }
        ],
        // img: [
        //   { required: true, message: '图片不能为空', trigger: 'blur' }
        // ],
        status: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
        startTime: [
          { required: true, validator: startTimeVal, trigger: 'change' }
        ],
        endTime: [
          { required: true, validator: endTimeVal, trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: { ...mapGetters(['customDict']) },
  watch: {
  },
  mounted () {
  },
  methods: {
    indexScriptModalSelect(ids) {
      this.form.scriptId = ids
      console.log('获取到的ids', ids)
    },
    indexScriptModalName(name) {
      this.form.scriptName = name
      console.log('获取到的剧本名', name)
    },
    showBindScript: function() {
      this.$refs.IndexScriptModal.open()
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        scriptId: null,
        scriptName: null,
        type: undefined,
        sponsorName: null,
        img: null,
        sort: null,
        status: 1,
        startTime: null,
        endTime: null,
        createTime: null,
        modifier: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    onDateChange(date, dateString) {
      console.log(date, dateString)
      this.form.startTime = dateString
    },
    onDateChange1(date, dateString) {
      console.log(date, dateString)
      this.form.endTime = dateString
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSponsor(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSponsor(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSponsor(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
